import React from "react";
import "../App.css";

class FoodRow extends React.Component {
  render() {
    return (
      <tr className="food-row">
        <td>{this.props.item.name}</td>
        <td>{this.props.item.type}</td>
        <td>{this.props.item.price}</td>
      </tr>
    );
  }
}

class FoodTable extends React.Component {
  render() {
    return (
      <table className="DataTable">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          {this.props.items.map((item) => (
            <FoodRow item={item} key={item.name} />
          ))}
        </tbody>
      </table>
    );
  }
}

class Food extends React.Component {
  render() {
    const foodItems = [
      { name: "Lasagna", type: "Hot Meal", price: "£4.50" },
      { name: "Toastie", type: "Sandwich", price: "£6.50" },
    ];

    return (
      <div className="food-container">
        <FoodTable items={foodItems} />
      </div>
    );
  }
}

export default Food;
